const MessageInput = ({
	label = "Mensagem",
	id,
	placeholder = "Digite sua mensagem...",
	register,
	errors,
	onChange = () => {},
	autoFocus = false,
	className,
	toUpperCase = false, // nesse caso, geralmente melhor manter minúsculas/naturais
}) => {
	const handleChange = (e) => {
		const { selectionStart, selectionEnd } = e.target;
		const value = toUpperCase ? e.target.value.toUpperCase() : e.target.value;
		e.target.value = value;
		onChange({ ...e, target: { ...e.target, value } });

		setTimeout(() => {
			e.target.setSelectionRange(selectionStart, selectionEnd);
		}, 0);
	};

	return (
		<div className={`input-box ${className}`}>
			<label htmlFor={id}>{label}</label>
			<textarea
				id={id}
				rows={5}
				className={`${errors[id] ? "error" : ""} `}
				placeholder={placeholder}
				autoFocus={autoFocus}
				{...register(id, {
					onChange: (e) => {
						handleChange(e);
						onChange(e);
					},
				})}
			/>
			{errors[id] && <p className="errors">{errors[id].message}</p>}
		</div>
	);
};

export default MessageInput;
